function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessfullOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.152762,0,0,0.152762,2.5,2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.933,0C106.974,0 0,106.974 0,238.933C0,370.892 106.974,477.866 238.933,477.866C370.892,477.866 477.866,370.892 477.866,238.933C477.726,107.033 370.834,0.141 238.933,0ZM238.933,443.733C125.825,443.733 34.133,352.041 34.133,238.933C34.133,125.825 125.825,34.133 238.933,34.133C352.041,34.133 443.733,125.825 443.733,238.933C443.611,351.991 351.991,443.611 238.933,443.733Z",
    style: {
      fill: "rgb(0,171,102)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.163225,0,0,0.163225,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.046,141.534C363.432,135.146 352.947,135.146 346.334,141.534L187.733,300.134L131.532,243.933C124.984,237.153 114.179,236.966 107.4,243.514C100.62,250.062 100.433,260.867 106.981,267.646C107.118,267.788 107.258,267.928 107.4,268.065L175.667,336.332C182.331,342.995 193.135,342.995 199.799,336.332L370.466,165.665C377.014,158.886 376.826,148.082 370.046,141.534Z",
    style: {
      fill: "rgb(0,171,102)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfullOrder);
export default __webpack_public_path__ + "static/media/successfull-order.350e7a32c350362836fd9d29b76fa9c1.svg";
export { ForwardRef as ReactComponent };